import styled from 'styled-components';

import { ListItemContainer, ListItemContent, ListItemProps } from './ListItem';

const NodeCube = styled.span<{ color: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 2px;
  width: 18px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 3px;
  margin-right: 4px;
  margin-top: 10px;

  border: ${({ color }) => `2px solid ${color}`};

  .firstLine {
    width: 13px;
    height: 1px;
    border-radius: 1rem;
    margin-left: 2px;
    background-color: ${({ color }) => color};
  }

  .secondLine {
    width: 7px;
    height: 1px;
    border-radius: 1rem;
    margin-left: 2px;
    background-color: ${({ color }) => color};
  }
`;

export const NodeListItem: React.FC<ListItemProps> = (props) => {
  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key} {...liProps}>
      <NodeCube color={option?.metadata?.color}>
        <div className='firstLine' />
        <div className='secondLine' />
      </NodeCube>
      <ListItemContent>
        <h1>{option?.label}</h1>
        {option?.metadata?.description && <p>{option.metadata.description}</p>}
      </ListItemContent>
    </ListItemContainer>
  );
};
